import { Component, Input, OnInit } from '@angular/core';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PfandrechtMasterDetailEntryMeta,
  PfandrechtVersionDetailEntryMeta,
  RechtMasterListEntry,
  RechtMasterListEntryMeta,
  RechtVersionId,
  RechtVersionListEntry
} from '../../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NavTarget } from '../../../../shared/components/link/link.component';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktGrundpfandrechtComponent } from '../../../../shared/kompaktdarstellung/grundpfandrecht/kompakt-grundpfandrecht.component';
import { KompaktStandardrechtComponent } from '../../../../shared/kompaktdarstellung/standardrecht/kompakt-standardrecht.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { ReadMoreComponent } from '../../../../shared/widgets/read-more/read-more.component';
import { BereinigungsmarkierungComponent } from '../../bereinigungsmarkierung/bereinigungsmarkierung.component';
import { BetragPipe } from '../../../../shared/pipes/simple/betrag.pipe';
import { NamenInhaberPfandrechtartPipe } from '../../../../shared/pipes/simple/namen-inhaber-pfandrechtart.pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';
import { YesNoPipe } from '../../../../shared/pipes/simple/yes-no.pipe';

@Component({
  selector: 'cap-pfandrecht-kopfdaten',
  templateUrl: './pfandrecht-kopfdaten.component.html',
  styleUrls: ['./pfandrecht-kopfdaten.component.scss'],
  imports: [
    KopfdatenelementComponent,
    KompaktGrundpfandrechtComponent,
    KompaktStandardrechtComponent,
    KompaktTimepointComponent,
    ReadMoreComponent,
    BereinigungsmarkierungComponent,
    TranslatePipe,
    BetragPipe,
    NamenInhaberPfandrechtartPipe,
    TranslateNamePipe,
    YesNoPipe
  ]
})
export class PfandrechtKopfdatenComponent implements OnInit {
  navTargets = NavTarget;

  @Input()
  recht: PfandrechtMasterDetailEntryMeta;
  @Input()
  versionId: RechtVersionId;

  ursprung: RechtMasterListEntryMeta;
  version: PfandrechtVersionDetailEntryMeta;
  maximalzinsfuss: string;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    keysToTranslate<
      RechtVersionListEntry.PfandrechtformEnum | RechtVersionListEntry.PfandrechtartEnum | RechtVersionListEntry.NamenInhaberEnum
    >([
      'EINZELPFANDRECHT',
      'GESAMTPFANDRECHT',
      'TEILPFANDRECHT',
      'GESAMTTEILPFANDRECHT',
      'PFANDOBLIGATION',
      'SCHULDBRIEF',
      'GUELT',
      'GRUNDPFANDVERSCHREIBUNG',
      'VORBEHALTENERVORGANG',
      'LEEREPFANDSTELLE',
      'REGISTERSCHULDBRIEF',
      'ALTRECHTLICH',
      'ANDEREART',
      'INHABER',
      'NAMEN'
    ]);
    keysToTranslate<string>([
      'AlteIdentifikation',
      'FremdeIdentifikation',
      'GesetzlichesPfandrecht',
      'Hinweis',
      'Löschgeschäft',
      'Maximalhypothek',
      'Maximalzinsfuss',
      'Grundpfandrechtart',
      'Grundpfandrechtform',
      'Pfandsumme',
      'ZinsUndAbzahlungsbestimmungen'
    ]);
  }

  get alteIdentifikation() {
    if (this.version && this.version.nummerAltDatum != null && this.version.nummerAltId != null) {
      return this.version.nummerAltDatum + ', ' + this.version.nummerAltId;
    }
  }

  ngOnInit() {
    this.version = this.recht.versions.find((v) => v.id.id === this.versionId.id);
    if (this.version) {
      this.ursprung = this.recht.ursprung;
      if (this.version.maximalzinsfuss) {
        this.maximalzinsfuss = this.version.maximalzinsfuss + '%';
      } else if (this.version.maximalhypothek) {
        this.maximalzinsfuss = this.translate.instant('Maximalhypothek');
      }
    }
  }

  onSelectDetail(recht: RechtMasterListEntry) {
    this.router.navigate(['../detail'], {
      relativeTo: this.route,
      queryParams: {
        versionId: recht.version.id.id,
        masterId: recht.id.id,
        rechtArt: recht.art,
        histEnum: recht.version.histInfo.histEnum
      }
    });
  }
}
